import React, { useState }  from 'react'
import axios from 'axios'
import { MdArrowLeft, MdArrowRight } from "react-icons/md"
const APIURL = process.env.NODE_ENV === 'production' ? `${process.env.REACT_APP_DB_ENV}` : `${process.env.REACT_APP_DB_ENV_TEST}`

export default function BookRentRoomSimple() {
  const [scheduleDisplay,setScheduleDisplay] = useState(false)
  const [reservation_data, setReservation_data] = useState([])
  const [slotDisplay,setSlotDisplay] = useState(false)
  const [startDate, setStartDate] = useState('')
  const [endDate, setEndDate] = useState('')
  const [msg, setMsg] = useState('')
  const [err, setErr] = useState('')
  function join(date, options, separator) {
    function format(option) {
      let formatter = new Intl.DateTimeFormat('en', option)
      return formatter.format(date)
    }
    return options.map(format).join(separator)
  }
  const today = join(new Date(), [{year: 'numeric'},{month: '2-digit'},{day: '2-digit'}], '-')
  const today_plus_3days_timestamp = new Date(`${today.slice(5,7)}/${today.slice(8,10)}/${today.slice(0,4)}`).getTime()+(1000*60*60*24*3)
  // user can book from 
  const today_plus_3days_format = join(new Date(today_plus_3days_timestamp), [{year: 'numeric'},{month: '2-digit'},{day: '2-digit'}], '-')
  const today_plus_90days_timestamp = new Date().getTime()+(1000*60*60*24*90)
  const today_plus_90days_format = join(new Date(today_plus_90days_timestamp), [{year: 'numeric'},{month: '2-digit'},{day: '2-digit'}], '-')
  function join(date, options, separator) {
    function format(option) {
      let formatter = new Intl.DateTimeFormat('en', option)
      return formatter.format(date)
    }
    return options.map(format).join(separator)
  }
  const onChange2StartDate = (e) => { 
      setStartDate(e.target.value)
  } 
  const onChange2EndDate = (e) => { 
      setEndDate(e.target.value)
  } 
  const onClick2Submit = ()=>{
      setErr('')
      setMsg('')
      function join(date, options, separator) {
      function format(option) {
          let formatter = new Intl.DateTimeFormat('en', option)
          return formatter.format(date)
      }
      return options.map(format).join(separator)
     }
     const startdate_plus_7days_timestamp = new Date(`${startDate.slice(5,7)}/${startDate.slice(8,10)}/${startDate.slice(0,4)}`).getTime()+(1000*60*60*24*7)
     const checkTerm = new Date(`${endDate.slice(5,7)}/${endDate.slice(8,10)}/${endDate.slice(0,4)}`).getTime()
      if(startDate==''){
        setErr('Please input start date.')
      }else if(endDate==''){
        setErr('Please input end date.')
      }else if(checkTerm<startdate_plus_7days_timestamp){
        setErr('You can only contract at least 7days of term.')
      }else{
        setMsg(`You are successfully submitted. Your contract starts on ${new Date(startDate).toLocaleDateString("en-US", { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' })} and ends on ${new Date(endDate).toLocaleDateString("en-US", { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' })}.`)
        setScheduleDisplay(false)
      }
  }
  return (
    <div>
      <div className='text-xs flex flex-col'>
      <div className='flex'>
        <div className='flex flex-col mr-2'>
          <label for='reservation_start_date'>Start Date</label>
          <input type='date' id='reservation_start_date' name='reservation_date' min={today_plus_3days_format} max={today_plus_90days_format} value={startDate}
          onChange={(x)=>onChange2StartDate(x)} 
          className={`${err!=''?'border-red-600':'border-gray-900'} border w-fit`}/>
        </div>
        <div className='flex flex-col'>
          <label for='reservation_end_date'>End Date</label>
          <input type='date' id='reservation_end_date' name='reservation_date' min={startDate}  value={endDate} 
          onChange={(x)=>onChange2EndDate(x)} 
          className={`${err!=''?'border-red-600':'border-gray-900'} border w-fit`}/>
        </div>
      </div>
      {err!='' ? <span className='text-xs text-red-700'>{err}</span>:''} 
      <div>
      </div>
      <button className='primary-btn text-xs w-fit mt-1' onClick={onClick2Submit}>Submit</button>
      {msg!='' ? <span className='text-xs'>{msg}</span>:''} 
      </div>
    </div>
  )
}